var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"5d0379ff1fb7d9cda3f1d975e26d6ca8001e92e2"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["react@unmind"]={id:"5d0379ff1fb7d9cda3f1d975e26d6ca8001e92e2"};
      